import update from 'immutability-helper';
import RecipientManagerConstants from 'SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerConstants';
import SelfServeBuilderResponsesConstants, { SelfServeBuilderResponsesNotifications } from './SelfServeBuilderResponsesConstants';

const initialState = {
  customTemplateSessions: [],
  documentName: '',
  isLoading: true,
  isNotificationError: false,
  isPublic: false,
  notification: null,
  publishedAt: null,
};

const SelfServeBuilderResponsesReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SelfServeBuilderResponsesConstants.SELF_SERVE_BUILDER_RESPONSES_NOTIFICATION_SET:
      return update(state, {
        notification: { $set: action.notification },
        isNotificationError: { $set: action.isError },
      });
    case SelfServeBuilderResponsesConstants.SELF_SERVE_BUILDER_RESPONSES_GET_REQUEST:
      return update(state, {
        isLoading: { $set: true },
      });
    case SelfServeBuilderResponsesConstants.SELF_SERVE_BUILDER_RESPONSES_GET_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        customTemplateSessions: { $set: action.data.custom_template_sessions },
        documentName: { $set: action.data.custom_template.name },
        isPublic: { $set: action.data.custom_template.public },
        publishedAt: { $set: action.data.custom_template.published_at },
      });
    case SelfServeBuilderResponsesConstants.SELF_SERVE_BUILDER_RESPONSES_GET_FAILURE:
      return update(state, {
        notification: { $set: action.error },
        isNotificationError: { $set: true },
        isLoading: { $set: false },
      });
    case SelfServeBuilderResponsesConstants.SELF_SERVE_BUILDER_RESPONSES_CANCEL_SUCCESS:
      return update(state, {
        customTemplateSessions: {
          $apply: arr => arr.filter(item => action.shareKeys.indexOf(item.share_key) < 0),
        },
      });
    case RecipientManagerConstants.RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_SUCCESS:
      return update(state, {
        notification: { $set: SelfServeBuilderResponsesNotifications.success },
        isNotificationError: { $set: false },
        customTemplateSessions: { $push: action.customTemplateSessions },
      });
    case RecipientManagerConstants.RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_FAILURE:
      return update(state, {
        notification: { $set: SelfServeBuilderResponsesNotifications.failure },
        isNotificationError: { $set: true },
      });
    case RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_UPDATE:
      return update(state, {
        isPublic: { $set: action.data.custom_template.public },
        publishedAt: { $set: action.data.custom_template.published_at },
      });
    default:
      return state;
  }
};

export default SelfServeBuilderResponsesReducer;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderResponses/SelfServeBuilderResponsesReducer.jsx